import { RoleNames, Actor } from 'core';

export function isSystemAdmin(actor: Actor | null): boolean {
  return !!actor && RoleNames.sysAdmin === actor.roleName;
}
